import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Exception for the Authorization Header
    if (req.url.match(/viacep/)) return next.handle(req);

    // Get token — safely handle null (login e outras rotas públicas)
    const accessToken: any = this.authService.getToken();
    const token = accessToken?.token;
    if (!token) return next.handle(req);

    // Clone headers and add Authorization
    // Não forçar content-type em uploads: FormData precisa do boundary
    // multipart gerado automaticamente pelo browser (setar aqui quebra o upload)
    let optHeades = req.body instanceof FormData
      ? req.headers.set('Authorization', `Bearer ${token}`)
      : req.headers
          .set('content-type', 'application/json; charset=utf-8')
          .set('Authorization', `Bearer ${token}`);

    // Clone request and set new headers
    const authReq = req.clone({ headers: optHeades });

    // Make the request
    return next.handle(authReq);
  }
}
